import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/seo"
import { Breadcrumb } from "gatsby-plugin-breadcrumb"
import CaseItem from "../components/CaseItem"

const CasePage = props => {
  const data = useStaticQuery(
    graphql`
      query {
        allContentfulCaseStudy(sort: { publishDate: DESC }) {
          edges {
            node {
              title
              id
              node_locale
              slug
              heroImage {
                gatsbyImageData(layout: CONSTRAINED, width: 800)
                title
                description
              }
              institution {
                name
                region {
                  name
                }
              }
              department {
                name
              }
            }
          }
        }
      }
    `
  )
  const {
    breadcrumb: { crumbs },
  } = props.pageContext
  const customCrumbLabel = props.location.pathname
    .replace("-", " ")
    .replace(/\//g, "")
  return (
    <Layout location={props.location}>
      <Seo title="Case Studies" lang="da-DK" pathname="cases" />
      <div className="content-wide">
        <div className="wide-container">
          <div className="wide-inner">
            <Breadcrumb
              crumbs={crumbs}
              crumbSeparator=" / "
              crumbLabel={customCrumbLabel}
            />
          </div>
        </div>
      </div>

      <div className="content-wide">
        <div className="wide-container">
          <div className="wide-inner">
            <div className="case-grid">
              {data.allContentfulCaseStudy.edges.map(edge => {
                if (edge.node.node_locale.toLowerCase() !== "da-dk") {
                  return null
                }
                return <CaseItem node={edge.node} key={edge.node.id} />
              })}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default CasePage
